import React from 'react';
import './EnergyPageCustom_Bus.css'
import DashboardMain_Bus from '../DashboardMain_Bus/DashboardMain_Bus';
import * as $ from 'jquery';
import { useCallback, useContext, useEffect, useState } from "react";
import { INIT_FILTER_STATE } from '../../../constants/driveglobalfilterinitalstates_bus';
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates_bus';
import useHttp from '../../../hook/use-http'
import ThreeGaugeChart_Bus from './ThreeGaugeChart_Bus';
import ConsumptionTables_Bus from './ConsumptionTables_Bus';
import Energyanalysis_Filters_Bus from './Energyanalysis_Filters_Bus';
import { decodeToken } from 'react-jwt';
import PieChartAm from './PieChartAm';
import HorizontalBarchart from './HorizontalBarchart';
import Energy_Consumption_Breakdown from './Energy_Consumption_Breakdown';
import { useSelector } from 'react-redux';
import { selectLoggedInUser } from "../../../redux/userSlice";
import ConsumptionTables_FleetEv_Bus from "./Energyanalysis_FleetEV_Bus/ConsumptionTables_FleetEv_Bus"

export default function Energyanalysis_Bus() {
  const tokenNew = JSON.parse(sessionStorage.user);
  let decodedToken = decodeToken(tokenNew.token);
  const city_name = decodedToken.city_name;
  const city_name_arr = city_name.split(",");
  const depo_name = decodedToken.depo_name;
  const depo_name_arr = depo_name.split(",");
  let sampleObj = (city_name != "") ? { ...INIT_FILTER_STATE, CITY: city_name_arr, DEPO: depo_name_arr } : INIT_FILTER_STATE
  const [gloablfilter, setGloablfilter] = useState(sampleObj)
  const { isLoading, error, sendReq: fetchData } = useHttp();

  const log_data = (data) => {
  }

  useEffect(() => {
    window.$("#button-1_Bus").checked = false
    fetchData({
      url: API_URL_MAIN + "auth/logging", body: {
        page_name: "energyanalysis_bus"
      }
    }, log_data)
  }, []);

  const [fromTableToFilter_vin, setFromTableToFilter_vin] = useState(0);
  const filterSubmited = useCallback((data) => {
    if (data.VIN_NUM.length === 1) {
      setFromTableToFilter_vin(data.VIN_NUM[0])
    }
    setGloablfilter(data);
  }, []);

  const singleVinSelected = (vin) => {
    let vin_num = vin.split(",");
    setFromTableToFilter_vin(vin_num[0])
    setGloablfilter((prevdata) => { return { ...prevdata, VIN_NUM: vin_num, pageSelected: 2 } });
  }

  const onreset = (data) => {
    setGloablfilter(data);
  }

  const loggedInUser = useSelector(selectLoggedInUser);

  return (
    <>
      <DashboardMain_Bus>
        <div className='main_hole_background'>
          <Energyanalysis_Filters_Bus onsubmit={filterSubmited} gloablfilter={gloablfilter} onreset={onreset} fromTableToFilter_vin={fromTableToFilter_vin} />
          <div className="container-fluid">
            <section className="kpi my-3">
              <div className="row">
                <div className="col-md-8 col-sm-12 col-lg-8">
                  <ThreeGaugeChart_Bus gloablfilter={gloablfilter} />
                  {(loggedInUser.flagForHideShow === "ERC") ?
                  <ConsumptionTables_Bus gloablfilter={gloablfilter} singleVinSelected={singleVinSelected} />
                  :
                  <ConsumptionTables_FleetEv_Bus gloablfilter={gloablfilter} singleVinSelected={singleVinSelected} />
                  }
                </div>
                <div className="col-md-4 col-sm-12 col-lg-4">
                  <PieChartAm gloablfilter={gloablfilter} />
                </div>
              </div>
            </section>
            <section className="kpi my-3">
              <div className="row pr-3">
                {/* <div className='col-md-5'> */}
                <div className={(loggedInUser.flagForHideShow === "ERC" ? 'col-md-5' : 'col-md-3')} >
                  <HorizontalBarchart gloablfilter={gloablfilter} />
                </div>
                <div className={(loggedInUser.flagForHideShow === "ERC" ? 'col-md-7 energyChartboxNew_Bus' : 'col-md-9 energyChartboxNew_Bus' )}>
                  <Energy_Consumption_Breakdown gloablfilter={gloablfilter} />
                </div>
              </div>
            </section>
          </div>
        </div>
      </DashboardMain_Bus >
    </>
  )
}